'use strict';

const loadExternalScript = (scriptSrc) => new Promise((resolve, reject) => {
    let scriptEl = document.querySelector('script[src="' + scriptSrc + '"]');

    if (scriptEl) {
        resolve(scriptEl);
        return;
    }

    scriptEl = document.createElement('script');
    scriptEl.type = 'text/javascript';
    scriptEl.async = true;
    scriptEl.src = scriptSrc;

    scriptEl.addEventListener('error', reject);
    scriptEl.addEventListener('abort', reject);
    scriptEl.addEventListener('load', function loadScriptHandler() {
        resolve(scriptEl);
    });

    document.head.appendChild(scriptEl);
});

module.exports = loadExternalScript;
